export default __webpack_public_path__ + "static/media/mastercard-logo.3405e9fa.png";